import { Reminder } from '@/communications/reminders/models/reminder-models';
import { TextRemindersRepository } from '@/communications/reminders/repositories/text-reminders-repository';
import { AbstractApiStore, AbstractEntityState } from '@/store/abstract-api-store';
import { Action, Module } from 'vuex-module-decorators';
import store from '@/store';
import { StoreModuleTypes } from '@/constants/store-constants';

export interface TextRemindersState extends AbstractEntityState<Reminder> {
    entities: Array<Reminder>;
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: StoreModuleTypes.TEXT_REMINDERS
})
export class TextRemindersStore extends AbstractApiStore<Reminder> implements TextRemindersState {
    readonly repository = new TextRemindersRepository();

    @Action
    public async init() {
        if (this.entities.length === 0) {
            await this.retrieveAll();
        }
    }

    // unfortunately getters don't work with vuex-module-decorator inheritance for some reason
    public get stored(): Array<Reminder> {
        return this.entities;
    }
}
